module.exports = __webpack_public_path__ + "static/media/dr-tharuka.ce64f99d.jpg";